import { ListFillEvents } from '../components/FillEvents/ListFillEvents';

import type { JSX } from "react";

export const FillEvents = (): JSX.Element => <ListFillEvents />;
